import type { UserEncoded } from "@silversea-ssc/dotcom-api-types/AuthStatus";

export type Loading = { status: "loading" };
export type Authenticated = { status: "authenticated"; user: UserEncoded };
export type Anonymous = { status: "anonymous" };
export type AuthError = { status: "error"; error: string };

export type AuthState = Loading | Authenticated | Anonymous | AuthError;

export const isLoading = (state: AuthState): state is Loading =>
  state.status === "loading";
export const isAuthenticated = (state: AuthState): state is Authenticated =>
  state.status === "authenticated";
export const isAnonymous = (state: AuthState): state is Anonymous =>
  state.status === "anonymous";
export const isError = (state: AuthState): state is AuthError =>
  state.status === "error";
